import React from 'react';

import { Link } from 'react-router-dom';

import { accountOrganizations } from '../web-routes';

import { OrganizationDropdown } from './organization-dropdown';

type Props = {
  accountId: number;
  orgId: number;
};

export const OrganizationInactivePage = ({ accountId, orgId }: Props) => (
  <div className="u-margin-0Auto u-padding-xl u-textAlign-center">
    <div className="typo-h4 u-margin-top-xl">
      We are sorry. This organization is currently inactive.
    </div>
    <div className="typo-title u-margin-y">
      Please select one of your other organizations or{' '}
      <Link to={accountOrganizations(accountId)} className="typo-link">
        view all organization information
      </Link>{' '}
      in your account page.
    </div>
    <div className="u-display-flex u-justifyContent-center u-alignItems-center u-margin-y-2x">
      <div className="u-width-300px u-margin-right-xl">
        <OrganizationDropdown accountId={accountId} orgId={orgId} displayInline />
      </div>
    </div>
  </div>
);
